export default __webpack_public_path__ + "static/media/Group 246.467afda1.png";